module.exports = __webpack_public_path__ + "static/img/ios-btn.50d7758b.png";